var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
// Humanised worklist status labels — never show the raw enum (e.g. "in_progress").
const STATUS_LABEL = {
    pending: "Pending", in_progress: "In progress", viewed: "✓ Viewed", done: "Done",
};
let PasWorklist = class PasWorklist extends LitElement {
    constructor() {
        super(...arguments);
        this.items = [];
        /** The currently-open patient, so the worklist can highlight the selection. */
        this.selectedId = null;
    }
    static { this.styles = css `
    :host, *, *::before, *::after { box-sizing: border-box; }
    :host { display: block; padding: 10px 8px; min-width: 168px; }
    ul { list-style: none; padding: 0; margin: 0; }
    li { border-bottom: 1px solid var(--color-slate-200); }
    /* Name sits on its own row above the status label — a fixed-width status
       pill sharing a row with the name is what was truncating longer names
       (e.g. "Raymond Tobias"); stacking removes the width contest entirely. */
    button { width: 100%; display: flex; flex-direction: column; align-items: flex-start;
             gap: 2px; text-align: left; background: transparent; border: 0;
             padding: 9px 10px; font-size: 13px; color: var(--color-slate-700);
             border-radius: 6px; cursor: pointer; }
    button:hover { background: var(--color-slate-100); }
    /* keep the selected patient highlighted (matches chart-navigator) */
    button.selected, button.selected:hover {
      background: var(--color-blue-50, #EFF6FF); color: var(--color-blue-700, #1D4ED8);
      font-weight: 600; box-shadow: inset 3px 0 0 var(--color-blue-600, #2563EB);
    }
    .name { width: 100%; white-space: normal; overflow-wrap: break-word; }
    .status { font-size: 10px; font-weight: 700; text-transform: uppercase;
              letter-spacing: .04em; color: var(--color-slate-400); }
    .status.done { color: var(--color-green-600); }
    .status.in_progress { color: var(--color-blue-600); }
    /* "Viewed" is a subtle, muted tick, not another attention-grabbing pill. */
    .status.viewed { color: var(--color-slate-400); text-transform: none;
                     letter-spacing: normal; font-weight: 500; }
  `; }
    select(item) {
        this.dispatchEvent(new CustomEvent("patient-select", {
            detail: { patientId: item.patientId }, bubbles: true, composed: true,
        }));
    }
    render() {
        return html `
      <ul aria-label="Worklist">
        ${this.items.map((it) => html `
          <li>
            <button data-pid=${it.patientId}
                    class=${it.patientId === this.selectedId ? "selected" : ""}
                    aria-current=${it.patientId === this.selectedId ? "true" : "false"}
                    @click=${() => this.select(it)}>
              <span class="name">${it.name}</span>
              <span class="status ${it.status}">${STATUS_LABEL[it.status] ?? it.status}</span>
            </button>
          </li>
        `)}
      </ul>
    `;
    }
};
__decorate([
    property({ attribute: false })
], PasWorklist.prototype, "items", void 0);
__decorate([
    property({ type: String })
], PasWorklist.prototype, "selectedId", void 0);
PasWorklist = __decorate([
    customElement("pas-worklist")
], PasWorklist);
export { PasWorklist };
